<template>
  <div id="blockchain-address">0x1234567..789102adfa</div>
</template>

<script>
export default {
  name: "BlockchainAddress",
};
</script>

<style lang="scss" scoped>
#blockchain-address {
  border-radius: 30px;
  background: #f7f7f7;
  // border: 1px solid #4c8bf5;
  padding: 10px;
  width: 230px;
  display: flex;
  justify-content: center;
}
</style>
>
